const COLLAPSED_HEIGHT = 250;

function initCollapsibleDescription() {
  // Prevent double-initialization
  if (document.querySelector('.fomo-collapsible-active')) return;

  // Primary: look for the user-added ID from the backend editor
  // Fallback: target the .fomo-product-description div from the liquid template
  let container = document.getElementById('fomo-collapsible-product-description');

  if (!container) {
    container = document.querySelector('.fomo-product-description');
  }

  if (!container) {
    console.warn('[Collapsible] No container found. Retrying...');
    return;
  }

  console.log('[Collapsible] Container found:', container);

  // Mark the container so CSS selectors work regardless of how it was found
  container.classList.add('fomo-collapsible-active');

  // Wrap all existing children into a single wrapper for height control
  const wrapper = document.createElement('div');
  wrapper.className = 'fomo-content-wrapper';
  while (container.firstChild) wrapper.appendChild(container.firstChild);
  container.appendChild(wrapper);

  // Inject scoped styles
  const style = document.createElement('style');
  style.textContent = `
    .fomo-collapsible-active {
      position: relative;
    }
    .fomo-collapsible-active .fomo-content-wrapper {
      transition: max-height 0.4s ease-in-out;
      overflow: hidden;
      display: flow-root;
    }
    .fomo-collapsible-active.collapsed::before {
      content: '';
      position: absolute;
      left: 0;
      bottom: 2.5em;
      width: 100%;
      height: 4em;
      pointer-events: none;
      background: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,0.95) 80%, rgba(255,255,255,1));
      z-index: 1;
    }
    .fomo-read-more-btn {
      background: none;
      border: none;
      padding: 0;
      margin-top: 1em;
      font: inherit;
      text-decoration: underline;
      cursor: pointer;
      display: block;
      clear: both;
      position: relative;
      z-index: 2;
    }
  `;
  document.head.appendChild(style);

  // Support optional data-collapsed-height attribute for per-product control
  const customHeight = parseInt(container.dataset.collapsedHeight, 10);
  const collapsedHeight = !isNaN(customHeight) ? customHeight : COLLAPSED_HEIGHT;

  wrapper.style.maxHeight = collapsedHeight + 'px';
  container.classList.add('collapsed');

  // Create the toggle button
  const btn = document.createElement('button');
  btn.className = 'fomo-read-more-btn';
  btn.setAttribute('aria-expanded', 'false');
  btn.textContent = 'Read more';
  container.appendChild(btn);

  console.log('[Collapsible] scrollHeight:', wrapper.scrollHeight, 'collapsedHeight:', collapsedHeight);

  // If content is short enough, no need for collapsing — hide the button
  setTimeout(() => {
    console.log('[Collapsible] Deferred scrollHeight:', wrapper.scrollHeight);
    if (wrapper.scrollHeight <= collapsedHeight + 20) {
      container.classList.remove('collapsed');
      wrapper.style.maxHeight = 'none';
      btn.style.display = 'none';
      console.log('[Collapsible] Content is short — collapsing disabled.');
    } else {
      console.log('[Collapsible] Collapsing active. Button visible.');
    }
  }, 200);

  // Toggle handler
  btn.addEventListener('click', () => {
    const isCollapsed = container.classList.contains('collapsed');

    if (isCollapsed) {
      container.classList.remove('collapsed');
      wrapper.style.maxHeight = wrapper.scrollHeight + 'px';

      // After transition ends, remove max-height so dynamic content works
      setTimeout(() => {
        if (!container.classList.contains('collapsed')) {
          wrapper.style.maxHeight = 'none';
        }
      }, 400);
    } else {
      // Set explicit height first so CSS transition can animate from it
      wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
      wrapper.offsetHeight; // force reflow

      container.classList.add('collapsed');
      wrapper.style.maxHeight = collapsedHeight + 'px';
    }

    btn.setAttribute('aria-expanded', (!isCollapsed).toString());
    btn.textContent = isCollapsed ? 'Read less' : 'Read more';
  });

  console.log('[Collapsible] Initialization complete.');
}

// Strategy: try multiple times to ensure the element exists
// 1) Try immediately (script is deferred, DOM should be parsed)
// 2) Try on DOMContentLoaded
// 3) Try on window load (last resort for lazy-loaded sections)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollapsibleDescription);
} else {
  // DOM already parsed — try now, then retry on load if needed
  initCollapsibleDescription();
}

window.addEventListener('load', () => {
  if (!document.querySelector('.fomo-collapsible-active')) {
    console.log('[Collapsible] Retrying on window load...');
    initCollapsibleDescription();
  }
});